import { useEffect } from 'react'
import {
  DocumentNode,
  LazyQueryResultTuple,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useLazyQuery,
} from '@apollo/client'
import useJamesApolloError from './useJamesApolloError'

export const useJamesApolloLazyQuery = <TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<TData, TVariables>,
): LazyQueryResultTuple<TData, TVariables> => {
  const onError = useJamesApolloError()

  const [loadData, result] = useLazyQuery(query, options)

  useEffect(() => {
    if (result.error) {
      onError(result.error)
    }
  }, [result.error, onError])

  return [loadData, result]
}
